import { useState, useEffect } from "react";
import { useDebouncedWindowResizeListener } from "./useDebouncedWindowResizeListener";

export const useMatchMedia = (media: string) => {
  const [matches, setMatches] = useState<boolean | null>(null);

  useEffect(() => {
    const matchedMedia = window.matchMedia(media);
    const mediaListener = () => setMatches(matchedMedia?.matches ?? false);

    mediaListener();
    matchedMedia.addEventListener(media, mediaListener);

    return () => matchedMedia.removeEventListener(media, mediaListener);
  }, [media]);

  return matches;
};

export const useMatchMediaListener = (media: string) => {
  const matchedMedia =
    typeof window !== "undefined" ? window.matchMedia(media) : undefined;

  const [matches, setMatches] = useState<boolean | null>(
    matchedMedia?.matches ?? false
  );

  const mediaListener = () => setMatches(matchedMedia?.matches ?? false);

  useDebouncedWindowResizeListener(mediaListener);

  return matches;
};
